/**
 * Convert a Date object to a specified string format
 *
 * |Strategy          |Equivalent to    |Examples (given in en-US locale)|
 * |---               |---              |---                             |
 * |'fullDate'        |'EEEE, MMMM d, y'|Friday, August 13, 2021         |
 * |'twoDigitDate'    |'MM/dd/yy'       |08/13/21                        |
 * |'twoDigitDateTime'|'MM/d/yy, h:mm a |08/13/21, 07:05:17 PM           |
 * |null (default)    |'M/dd/yyyy'      |8/13/2021                       |
 *
 * @param {Date | string | number | null} date
 * @param {'fullDate' | 'twoDigitDate' | 'twoDigitDateTime' | null} strategy
 * @param locale
 */
export const dateFormat = (date, strategy, locale = 'en-US') => {
  if (!date) {
    return 'N/A';
  }
  switch (strategy) {
    case 'fullDate':
      return new Date(date).toLocaleDateString(locale, {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
      });
    case 'twoDigitDate':
      return new Date(date).toLocaleDateString(locale, {
        year: '2-digit', month: '2-digit', day: '2-digit'
      });
    case 'twoDigitDateTime':
      return new Date(date).toLocaleDateString(locale, {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    default:
      return new Date(date).toLocaleDateString(locale, {});
  }
};
